import a from "../../assets/images/New folder/slide/1.png";
import b from "../../assets/images/New folder/slide/2.png";
import c from "../../assets/images/New folder/slide/3.png";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import { Pagination } from "swiper";
import { useContext } from "react";
import TrackContext from "context/TracksContext";
export default function SliderKooh({ banners }) {
  const { setSelectedTrackSearch, setChangePlayList } = useContext(TrackContext)
  return (
    <div className="slider-kooh">
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className="mySwiper"
        breakpoints={{
          700: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
      >
        {banners.length !== 0 ? banners.map(val => {
          return (
            <SwiperSlide className="text-center" >
              <img src={`http://ava.tatdemo.ir/${val.pics[0].path}`} className="slide-img" style={{ cursor: "pointer" }} onClick={e => {
                if (val.audios.length > 0) {
                  setSelectedTrackSearch(val.audios[0]);
                  setChangePlayList((prev) => !prev);
                }
              }} />
            </SwiperSlide>
          )
        }) : ""}
        {/* <SwiperSlide className="text-center">
          <img src={a} className="slide-img" />
        </SwiperSlide>
        <SwiperSlide className="text-center">
          <img src={b} className="slide-img" />
        </SwiperSlide>
        <SwiperSlide className="text-center">
          <img src={c} className="slide-img" />
        </SwiperSlide> */}
      </Swiper>
    </div>
  );
}
